import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Grid, Box } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { map, findIndex, find } from "lodash";
import uuid from "react-uuid";

import { currentAssetSliceActions } from "../../Store/Slices/CurrentAssetSlice";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";
import { AssignmentIsOpen, getOneRatingAssignmentLog } from "./SelfLearnCheck";

import {
  getAssignmentData,
  getTasksData,
  getResumeAssignmentData,
  dropSummaryLog,
  getSpecialAssessmentLog,
} from "./Services";
import { concatAllArrays } from "../../Js/Common";
import StudentCard from "../../Components/Card/StudentCard";
import Confirmation from "../../Components/Modal/Confirmation";
import Placeholder from "../../Components/UI/Placeholder";

import {
  getFormatedDate,
  getTimeStamp,
  getFormatedTimeOnly,
} from "../../Js/TimeAndDate";

const AssignmentList = (props) => {
  const paginationVal = 22;

  // Hooks
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();
  const listInnerRef = useRef();

  // State
  const [assignmentData, setAssignmentData] = useState([]);

  const [confirmModal, setConfirmModal] = useState(false);
  const [alertFlag, setAlertFlag] = useState(false);
  const [currentAssignmentId, setCurrentAssignmentId] = useState(null);
  const [allAssets, setAllAssets] = useState([]);

  const [isFetching, setIsFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [skipData, setSkipData] = useState(0);
  const [limitData, setLimitData] = useState(paginationVal);
  const [totalData, setTotalData] = useState(0);

  const [selfLearnErrModl, setSelfLearnErrModl] = useState(false);
  const [selfLearnErr, setSelfLearnErr] = useState("");

  const [futureTimeErrModl, setFutureTimeErrModl] = useState(false);
  const [futureTimeErr, setFutureTimeErr] = useState("");

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { siteConfig } = useSelector((state) => state.defs);
  const { loader } = useSelector((state) => state.common);

  useEffect(() => {
    if (props.filter || isFetching) {
      let innerFun = async () => {
        dispatch(commonSliceActions.setLoader(true));
        await getData();
      };
      dispatch(currentAssetSliceActions.resetState());
      innerFun();
    }
  }, [props.filter, isFetching, siteConfig]);

  // useEffect(() => {
  //   console.log("SSuserInfo", siteConfig.customer.addOnInfo.isSelfLearning);
  // }, [siteConfig]);

  const getData = async () => {
    let resAssignmentData = await getAssignmentData({
      createdBy: null,
      userId: userInfo.uid,
      filterBy: props.filter ? props.filter.toLowerCase() : "",
      userType: "learner",
      site_uuid: userInfo.site_uuid,
      skip: skipData,
      limit: limitData,
      totalData: totalData,
      order: siteConfig.customer?.addOnInfo?.isSelfLearning ? 1 : -1,
      isSelfLearn: siteConfig.customer?.addOnInfo?.isSelfLearning
        ? siteConfig.customer?.addOnInfo?.isSelfLearning
        : false,
    });
    console.log("#######resAssignmentData", resAssignmentData);
    // setTotalData(resAssignmentData.data.total);
    setIsFetching(false);
    setIsLoading(false);
    dispatch(commonSliceActions.setLoader(false));

    if (skipData == 0) {
      setTotalData(resAssignmentData.data.total);
      props.setTotalNumber(resAssignmentData.data.total);
      setAssignmentData(resAssignmentData.data.data);
      props.setAssignmentNumber(resAssignmentData.data.data.length);
    } else {
      let newData = [...assignmentData, ...resAssignmentData.data.data];
      props.setAssignmentNumber(newData.length);
      setAssignmentData(newData);
    }
  };

  const goToAssignment = async (obj) => {
    setCurrentAssignmentId(obj.uid);
    if (siteConfig.customer?.addOnInfo?.isSelfLearning) {
      let minimumonelog = await getOneRatingAssignmentLog({
        target: obj.uid,
        actor: userInfo.uid,
        site_uuid: userInfo.site_uuid,
        verb: "ratingAssignment",
      });

      if (minimumonelog?.data?.data?.length > 0) {
        dispatch(currentAssetSliceActions.setFromCompletedTab(true));
      }
      // if (isNaN(Number(obj.title))) {
      //   validAssignmentGo(obj);
      // } else {
      if (props.filter.toLowerCase() == "expired") {
        return false;
      }
      // if (props.filter.toLowerCase() === "pending") {
      //   validAssignmentGo(obj);
      // }
      if (props.filter.toLowerCase() == "new" && obj.title == 1) {
        let specialExamLogRes = await getSpecialAssessmentLog(
          userInfo.uid,
          userInfo.site_uuid
        );
        console.log("specialExamLogRes", specialExamLogRes);
        if (
          specialExamLogRes?.data?.data.length > 0
        ) {
          validAssignmentGo(obj);
        } else {
          setSelfLearnErr("Please attempt the assessment first.");
          setSelfLearnErrModl(true);
        }
      } else {
        let lastAssignmentName =
          props.filter.toLowerCase() === "new" ? obj.title - 1 : obj.title;
        let statusObj = await AssignmentIsOpen(
          props.filter.toLowerCase(),
          lastAssignmentName,
          userInfo,
          obj
        );
        console.log("ASDS", statusObj);
        if (!statusObj.status) {
          setSelfLearnErr(statusObj.message);
          setSelfLearnErrModl(true);
        } else {
          validAssignmentGo(obj);
        }
      }
    } else {
      validAssignmentGo(obj);
    }
  };

  const validAssignmentGo = async (obj) => {
    if (
      (!siteConfig.customer?.addOnInfo?.isSelfLearning &&
        (props.filter.toLowerCase() == "expired" ||
          props.filter.toLowerCase() == "finished")) ||
      (siteConfig.customer?.addOnInfo?.isSelfLearning &&
        props.filter.toLowerCase() == "expired")
    ) {
      return false;
    }

    if (props.filter.toLowerCase() === "pending" && obj.is_exam) {
      setAlertFlag(true);
      return false;
    }
    let tasks = await getTasksData(obj.tasks.tasks, userInfo.site_uuid);
    let finalArray = tasks.data.map((val) => {
      return val.data1.exersices.map((asset) => {
        return { taskID: val.uid, id: asset };
      });
    });
    dispatch(
      currentAssetSliceActions.setLearnerDefaults(obj.defaults.defaults)
    );
    dispatch(
      currentAssetSliceActions.setNumberOfAttemptes(
        +obj.defaults.defaults.noofattempts
      )
    );
    if (obj.is_exam) {
      dispatch(currentAssetSliceActions.setEexamTime(obj.estimated_time));
    }
    setAllAssets(concatAllArrays(finalArray));

    if (props.filter.toLowerCase() == "new") {
      redirect(obj.uid, concatAllArrays(finalArray), tasks.data[0]["tasktype"]);
    } else {
      if (
        siteConfig.customer?.addOnInfo?.isSelfLearning &&
        props.filter.toLowerCase() == "finished"
      ) {
        redirect(
          obj.uid,
          concatAllArrays(finalArray),
          tasks.data[0]["tasktype"]
        );
      }
      if (props.filter.toLowerCase() == "pending") {
        console.log("SLLSLSL");
        resumeAssignment(
          obj.uid,
          concatAllArrays(finalArray),
          tasks.data[0]["tasktype"]
        );
      }
    }
  };

  const resumeAssignment = async (assignmentId, assets, tasktype) => {
    let lastAttemptedAssetData = await getResumeAssignmentData(
      assignmentId,
      userInfo.uid,
      userInfo.site_uuid
    );
    console.log("lastAttemptedAssetData",lastAttemptedAssetData);
    dispatch(
      currentAssetSliceActions.setSessionUid(
        lastAttemptedAssetData.data[0]["session_uid"]
      )
    );
    sessionStorage.setItem("assignmentAssets", JSON.stringify(assets));
    sessionStorage.setItem(
      "lastContext",
      JSON.stringify(lastAttemptedAssetData.data[0]["context"])
    );
    console.log("LLLLLLLLLLLLLLL");
    navigation(`/Assignment/Content/${assignmentId}`);
  };

  const redirect = async (assignmentId, assets, tasktype) => {
    await dropSummaryLog(
      map(assets, "id"),
      assignmentId,
      userInfo,
      siteConfig.customer?.addOnInfo?.isSelfLearning
    );
    dispatch(currentAssetSliceActions.setSessionUid(uuid()));
    setConfirmModal(false);
    if (tasktype == "assets") {
      sessionStorage.setItem("assignmentAssets", JSON.stringify(assets));
      navigation(`/Assignment/Content/${assignmentId}`);
    } else {
      sessionStorage.setItem("assignmentAssets", JSON.stringify(assets));
      navigation(`/Assignment/Book/${assignmentId}/${assets[0].id}`);
    }
    // navigation.navigate("Assignment", {
    //   screen: "AssignmentAttempt",
    //   params: { assets: allAssets, assignmentId: currentAssignmentId },
    // });
  };

  const handleLoadMore = () => {
    if (assignmentData && +assignmentData.length < +totalData) {
      setIsLoading(true);
    }
    setTimeout(() => {
      if (skipData / paginationVal < Math.ceil(totalData / paginationVal) - 1) {
        let totSkipData = skipData + limitData;
        console.log("totSkipData", totSkipData);
        setSkipData(() => totSkipData);
        setLimitData(() => limitData);
        setIsFetching(() => true);
      }
    }, 1000);
  };

  const handleInfinityScroll = () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      let totalHeight = Math.ceil(scrollTop + clientHeight);
      if (
        totalHeight >= scrollHeight ||
        totalHeight == scrollHeight - 1 ||
        totalHeight === scrollHeight
      ) {
        return true;
      }
      return false;
    }
  };

  return (
    <Grid
      container
       
      onScroll={() => {
        if (handleInfinityScroll()) {
          handleLoadMore();
        }
      }}
      ref={listInnerRef}
      sx={{
        gap: 3,
        height: "70vh",
        overflow: isLoading ? "hidden" : "auto",
        justifyContent: "flex-start",
        mx: 3,
        width: "100%",
        paddingLeft: "2px",
        paddingBottom: "2px",
        "@media (min-width: 1636px)": { mx: 7 },
      }}
    >
      {assignmentData && assignmentData.length > 0 && (
        <>
          {assignmentData.map((obj, index) => {
            return (
              <div key={`${index}_assignments`}>
                <StudentCard
                  title={obj.title}
                  // secondaryText= {assignmentData.length > 0 ? `${assignmentData.length}/${totalData}` : ``}
                  todayFutureTime={
                    getTimeStamp(obj.commences) > Date.now()
                      ? getFormatedTimeOnly(obj.commences)
                      : null
                  }
                  subtitle={`${obj.is_exam ? "E-Exam" : ""}`}
                  secondarytitle={`Trainer: ${obj.teachername}`}
                  line1={`Due: ${getFormatedDate(
                    obj.expiries,
                    "DD MMM YY | HH:mm"
                  )}`}
                  progress={
                    obj.totalAttemptedAssets
                      ? `${Math.round(
                          (+obj.totalAttemptedAssets / +obj.totalAssets) * 100
                        )}`
                      : null
                  }
                  description={
                    siteConfig.customer?.addOnInfo?.isSelfLearning
                      ? obj.description
                      : ""
                  }
                  press={() => {
                    if (getTimeStamp(obj.commences) > Date.now()) {
                      setFutureTimeErr(
                        `Assignment can be accessed after ${getFormatedTimeOnly(
                          obj.commences
                        )} !`
                      );
                      setFutureTimeErrModl(true);
                    } else {
                      goToAssignment(obj);
                    }
                  }}
                  leftBottom={obj.assignmentperform}
                />
              </div>
            );
          })}
        </>
      )}
      {!loader && assignmentData && assignmentData.length == 0 && (
        <Placeholder
          primaryText="No assignment found"
          secondaryText="No data found!"
          image="assign"
        ></Placeholder>
      )}
      <Confirmation
        image="error"
        primaryText="You are only permitted to take the E exam once."
        visible={alertFlag}
        alert={true}
        timeout={6000}
        toggleModal={(flag) => setAlertFlag(flag)}
      ></Confirmation>
      <Confirmation
        image="error"
        primaryText={selfLearnErr}
        visible={selfLearnErrModl}
        alert={true}
        timeout={6000}
        toggleModal={(flag) => setSelfLearnErrModl(flag)}
      ></Confirmation>
      <Confirmation
        image="error"
        primaryText={futureTimeErr}
        visible={futureTimeErrModl}
        alert={true}
        timeout={4000}
        toggleModal={(flag) => setFutureTimeErrModl(flag)}
      ></Confirmation>
    </Grid>
  );
};
const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default AssignmentList;
